// import { CalendarIcon } from 'lucide-react';
import { cn, formatDateString } from '@/lib/utils';
import { useEffect } from 'react';
import { useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

export const parseDateString = (str) => {
  if (!str) return null;

  // Remove any leading/trailing spaces
  str = str.trim();

  // Check for invalid patterns
  if (
    str.match(/^[0]+[-][0]+[-][0]+$/) || // 00-00-0000
    str.match(/^[0]+$/) || // 0000
    str === '0'
  ) {
    // 0
    return null;
  }

  const [dd, mm, yyyy] = str.split('-').map(Number);

  // Additional validation for zeros and minimum values
  if (
    !dd ||
    !mm ||
    !yyyy ||
    yyyy < 1000 ||
    yyyy > 9999 || // Reasonable year range
    dd === 0 ||
    mm === 0
  ) {
    // No zero day/month
    return null;
  }

  if (dd < 1 || dd > 31 || mm < 1 || mm > 12) return null;

  // Check for valid date (handles months with different days)
  const date = new Date(yyyy, mm - 1, dd);
  if (
    date.getFullYear() !== yyyy ||
    date.getMonth() !== mm - 1 ||
    date.getDate() !== dd
  ) {
    return null;
  }
  return date;
};

const DatePickerInput = ({
  value,
  onChange,
  onBlur,
  maxDate,
  className,
  placeholder,
  ...rest
}) => {
  const [inputValue, setInputValue] = useState('');

  // Update input value when prop changes
  useEffect(() => {
    if (!value) {
      setInputValue('');
      return;
    }
    // Handle YYYY-MM-DD format from API
    if (value.match(/^\d{4}-\d{2}-\d{2}$/)) {
      const [yyyy, mm, dd] = value.split('-');
      setInputValue(`${dd}-${mm}-${yyyy}`);
    }
    // Handle ISO date format (2025-08-04T00:00:00.000Z)
    else if (value.match(/^\d{4}-\d{2}-\d{2}T/)) {
      const datePart = value.split('T')[0]; // Extract "2025-08-04" part
      const [yyyy, mm, dd] = datePart.split('-');
      setInputValue(`${dd}-${mm}-${yyyy}`);
    } else {
      setInputValue(value);
    }
  }, [value]);

  const handleChange = (date) => {
    if (!date) {
      setInputValue('');
      onChange('');
      return;
    }

    // Format the date when selecting from the calendar
    const formattedDate = formatDateString(date);
    setInputValue(formattedDate);
    onChange(formattedDate);
  };

  return (
    <div className="flex flex-col">
      <DatePicker
        {...rest}
        selected={parseDateString(inputValue)}
        onChange={handleChange}
        onSelect={handleChange}
        onBlur={onBlur}
        maxDate={maxDate}
        placeholderText={placeholder || 'DD-MM-YYYY'}
        className={cn(
          'border border-input text-foreground bg-background rounded-md h-11 px-3 py-3 w-full',
          className,
        )}
        dateFormat="dd-MM-yyyy"
        showYearDropdown
        scrollableYearDropdown
        yearDropdownItemNumber={100}
        showMonthDropdown
        scrollableMonthDropdown
        isClearable
        autoComplete="off"
        // showIcon
        // icon={<CalendarIcon className='h-7 opacity-50'  />}
      />
      <p className="text-[12px] text-muted-foreground italic">
        <span className="font-bold">Note:</span> Date must be DD-MM-YYYY format
      </p>
    </div>
  );
};

export default DatePickerInput;
